export function getReadableNumber(n: number): string {
  if (n > 999999999)
    return (n / 1000000000).toFixed(1).replace(/\.0$/, '') + 'B'
  if (n > 999999) return (n / 1000000).toFixed(1).replace(/\.0$/, '') + 'M'
  if (n > 999) return (n / 1000).toFixed(1).replace(/\.0$/, '') + 'K'

  return (+parseFloat(n.toString()).toFixed(1)).toString()
}
